import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Styles } from './style';
import { RegistrationFormData } from '../PropertyRegister/data';
import AuthenticatedLayout from '@screens/Authenticated/Layout/Layout';

const RegistrationFormDetailScreen: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const property = RegistrationFormData[parseInt(id || '0', 10)];

  if (!property) {
    return <p>Propriedade não encontrada.</p>;
  }

  return (
    <AuthenticatedLayout>
      <h1>Detalhes do Imóvel</h1>
      <Styles.RectangleBar />
      <Styles.DetailContainer>
        <h2>Informações do Cliente</h2>
        <p>
          <strong>Nome:</strong> {property.clientInfo.name}
        </p>
        <p>
          <strong>Email:</strong> {property.clientInfo.email}
        </p>
        {property.clientInfo.phone && (
          <p>
            <strong>Telefone:</strong> {property.clientInfo.phone}
          </p>
        )}
        <h2>Informações do Imóvel</h2>
        <p>
          <strong>Condição:</strong> {property.propertyInfo.condition}
        </p>
        <p>
          <strong>Tipo:</strong> {property.propertyInfo.type}
        </p>
        <p>
          <strong>Quartos:</strong> {property.propertyInfo.bedrooms}
        </p>
        <p>
          <strong>Suítes:</strong> {property.propertyInfo.suites}
        </p>
        <p>
          <strong>Descrição:</strong> {property.propertyInfo.description}
        </p>

        <h2>Endereço</h2>
        <p>
          <strong>Rua:</strong>
          {property.address.street},{property.address.number}
        </p>
        <p>
          <strong>Bairro:</strong> {property.address.neighborhood}
        </p>
        <p>
          <strong>CEP:</strong> {property.address.zipCode}
        </p>
        {property.address.complement && (
          <p>
            <strong>Complemento:</strong> {property.address.complement}
          </p>
        )}
      </Styles.DetailContainer>
      <Styles.ButtonContainer>
        <Styles.BackButton onClick={() => navigate(-1)}>
          Voltar
        </Styles.BackButton>
      </Styles.ButtonContainer>
    </AuthenticatedLayout>
  );
};

export default RegistrationFormDetailScreen;
